export const isAudioSupported = () => {
  if (typeof window === 'undefined') {
    return false;
  }

  return !!(window.AudioContext || window.webkitAudioContext);
};
